import { io, type ManagerOptions, type Socket, type SocketOptions } from 'socket.io-client'
import { getStoredAccessToken } from '@/lib/auth'

export interface CreateSocketOptions {
	/** Socket.IO namespace. Empty / omitted = default `/`. */
	namespace?: string
	path?: string
	transports?: ManagerOptions['transports']
	auth?: Record<string, unknown>
	query?: Record<string, unknown>
	autoConnect?: boolean
}

function getSocketBaseUrl(): string {
	const socketUrl = import.meta.env.VITE_PLAYER_SOCKET_URL?.trim()

	if (!socketUrl) {
		console.warn('VITE_PLAYER_SOCKET_URL is not configured')
		return ''
	}

	return socketUrl.replace(/\/$/, '')
}

export function createSocket(options: CreateSocketOptions): Socket {
	const baseUrl = getSocketBaseUrl()
	const namespace = options.namespace?.trim() ?? ''
	const staticAuth = options.auth

	const socketOptions: Partial<ManagerOptions & SocketOptions> = {
		path: options.path ?? '/socket.io',
		transports: options.transports ?? ['websocket'],
		autoConnect: options.autoConnect ?? true,
		reconnection: true,
		reconnectionAttempts: Infinity,
		reconnectionDelay: 1000,
		// Resolve auth on every (re)handshake so the JWT is never stale/missing.
		auth: (cb: (data: Record<string, unknown>) => void) => {
			const token = (typeof staticAuth?.token === 'string' && staticAuth.token) || getStoredAccessToken() || undefined
			cb({
				...(staticAuth ?? {}),
				token,
			})
		},
		query: options.query,
	}

	const url = namespace && namespace !== '/' ? `${baseUrl}${namespace.startsWith('/') ? namespace : `/${namespace}`}` : baseUrl

	return io(url, socketOptions)
}
